<div class="flex flex-col gap-4" data-testid="approvals-history-list">
  @if (availableTaList().length > 0) {
    <div class="flex gap-2 items-center">
      <input type="text"
             pInputText
             data-testid="approvals-history-search"
             [(ngModel)]="searchStr"
             class="w-1/2"
             pSize="small"
             placeholder="Type to filter by TA number, destination, project code, status or staff..."
      />
      <div class="bg-white rounded-lg">
        <p-button outlined severity="secondary"
                  size="small"
                  (onClick)="clearSearchStr()">Clear</p-button>
      </div>
      <div class="flex-1"></div>
      <div class="text-xs text-slate-500">
        Showing {{filteredTaList().length}} of {{store.approvalHistoryTaListCache()?.totalCount}} results
      </div>
      <div class="px-3">
        <p-button label="Reload&nbsp;List"
                  size="small"
                  severity="primary"
                  icon="fa-solid fa-arrow-rotate-right"
                  (onClick)="reloadTaList()"></p-button>
      </div>
    </div>

    <div #scrollContainer scrollHeight [bottomPadding]="120" class="rounded-lg border-[1px] border-surface-300 overflow-y-auto">
      <p-table [value]="filteredTaList()"
               data-testid="approvals-history-table"
               stripedRows
               [tableStyle]="{'min-width': '40rem'}"
               class="ta-list rounded-lg">
        <ng-template #header>
          <tr class="text-datatable-header-cell-color text-xs font-semibold font-['Roboto_Condensed']">
            <th class="rounded-tl-lg ta-col-prepaid"></th>
            <th class="ta-col-attachment"></th>
            <th>TA Number</th>
            <th pSortableColumn="startDate" style="align-items: center">
              <div class="flex items-center gap-2">
                Travel Date
                <p-sortIcon field="startDate" />
              </div>
            </th>
            <th>Status</th>
            <th>Primary Traveller</th>
            <th>No. of Travellers</th>
            <th>Project Code</th>
            <th style="padding-left: 4px; padding-right: 4px; text-align: center;">Approved TA Value</th>
            <th style="padding-left: 4px; padding-right: 4px; text-align: center;">Total TA Value</th>
            <th class="ta-col-actions">Actions</th>
            <th class="rounded-tr-lg ta-col-comments"></th>
          </tr>
        </ng-template>
        <ng-template #body let-taSubmission let-rowIndex="rowIndex">
          <tr class="text-xs font-normal font-['Roboto_Condensed'] hover:cursor-pointer" (click)="setSelectedTa(taSubmission); $event.stopPropagation()">
            <td class="ta-col-prepaid" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id), 'rounded-bl-lg' : (rowIndex === availableTaList().length - 1)}">
              <prepaid-indicator [taDetails]="taSubmission"></prepaid-indicator>
            </td>
            <td class="ta-col-attachment" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
              <attachment-indicator [taDetails]="taSubmission"></attachment-indicator>
            </td>
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
              <button class="text-primary-500 hover:underline font-semibold cursor-pointer"
                      (click)="viewTaSubmission(taSubmission); $event.stopPropagation()">
                {{taSubmission.taNumber}}
              </button>
            </td>
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.startDate | date:'dd/MM/yy'}}</td>
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
              <p-chip>
                <div class="whitespace-nowrap">{{toTAStatusText(taSubmission.status)}}</div>
              </p-chip>
            </td>
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
              <div class="flex gap-1 items-center">
                @if (taSubmission.travellerCount > 1) {
                  <i class="fa-solid fa-users"></i>
                } @else {
                  <i class="fa-solid fa-user"></i>
                }
                <span class="text-nowrap">{{taSubmission.primaryTraveller?.details?.name}}</span>
              </div>
            </td>
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.travellerCount}}</td>
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.projectCode}}</td>
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}" style="padding: 2px 4px;"><ta-cost-bubble severity="outlined" [tableVersion]="true" [value]="taSubmission.originalValue ?? 0"></ta-cost-bubble></td>
            <!-- A CancelApproved TA has been zeroed: flagged red, as the old Current Value cell did. -->
            <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}" style="padding: 2px 4px;"><ta-cost-bubble [severity]="taSubmission.status === 'CancelApproved' ? 'danger' : 'outlined'" [subtitle]="taSubmission.status === 'CancelApproved' ? 'Cancelled' : undefined" [tableVersion]="true" [value]="taSubmission.currentValue ?? taSubmission.originalValue ?? 0"></ta-cost-bubble></td>
            <td class="ta-col-actions" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}" style="padding: 6px;">
              <div class="flex flex-col justify-start">
                <p-button [style]="{height:'1.8em'}" [text]="true" severity="primary" size="small" (onClick)="setSelectedTa(taSubmission); $event.stopPropagation()"><span class="text-nowrap">View Summary</span></p-button>
                <p-button [style]="{height:'1.8em'}" [text]="true" severity="primary" size="small" (onClick)="viewTaSubmission(taSubmission)"><span class="text-nowrap">Review Full TA</span></p-button>
              </div>
            </td>
            <td class="ta-col-comments" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id), 'rounded-br-lg' : (rowIndex === availableTaList().length - 1)}">
              <ta-comment-count [count]="taSubmission.commentCount"></ta-comment-count>
            </td>
          </tr>
        </ng-template>
        <ng-template #footer>
          @if (filteredTaList().length === 0) {
            <tr class="text-xs font-normal font-['Roboto_Condensed']">
              <td class="rounded-bl-lg rounded-br-lg " colspan="12"> <i>Your search returned no results.</i></td>
            </tr>
          }
        </ng-template>
      </p-table>

      @if (canLoadMore()) {
        <div #loadMoreSentinel class="flex items-center justify-center gap-3 py-3">
          <p-button label="Load More"
                    data-testid="approvals-history-load-more"
                    severity="secondary"
                    size="small"
                    icon="fa fa-arrow-down"
                    [disabled]="isLoading()"
                    (onClick)="loadMore()">
          </p-button>
        </div>
      }
    </div>
  } @else if (isLoading()) {
    <div class="self-stretch justify-start text-slate-500 text-sm font-normal font-['Inter'] leading-6">Loading...</div>
  } @else {
    <div class="flex gap-2 items-center">
      <div data-testid="approvals-history-empty" class="self-stretch flex items-center justify-start text-slate-500 text-sm font-normal font-['Inter'] leading-6">You have no approval history.</div>
      <div class="flex-1"></div>
      <div class="px-3">
        <p-button label="Reload List"
                  size="small"
                  severity="primary"
                  icon="fa-solid fa-arrow-rotate-right"
                  (onClick)="reloadTaList()"></p-button>
      </div>
    </div>
  }
</div>
